// Action Types
export const SET_PENDING_TOKEN = 'auth/setPendingToken'
export const SET_MFA_TYPE = 'auth/setMFAType'
export const RESET_MFA = 'auth/resetMFA'
export const CODE_ERROR = 'auth/codeError'

// Action Creators
export const setPendingToken = (payload) => ({ type: SET_PENDING_TOKEN, payload })
export const resetMFA = () => ({ type: RESET_MFA })
export const setMFAType = (mfaType, uri, manualKey) => ({
  type: SET_MFA_TYPE,
  mfaType,
  uri,
  manualKey,
})
export const setCodeError = (codeError) => ({ type: CODE_ERROR, codeError })

// State
export const initialState = {
  mfaType: null,
  pendingToken: null,
  organizationID: null,
  username: null,
  uri: null,
  manualKey: null,
  enrolling: false,
  codeError: false,
}

// Reducer
export default function mfaReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PENDING_TOKEN:
      return {
        ...initialState,
        pendingToken: action.payload.pending_token,
        mfaType: action.payload.mfa_type,
        organizationID: action.payload.organization_id,
        username: action.payload.username,
      }
    case SET_MFA_TYPE:
      return {
        ...state,
        mfaType: action.mfaType,
        uri: action.uri,
        manualKey: action.manualKey,
        enrolling: true,
      }
    case RESET_MFA:
      return initialState
    case CODE_ERROR:
      return { ...state, codeError: action.codeError }
    default:
      return state
  }
}
